import IColumn from "models/IColumn";

export const columnsHeader: IColumn[] = [
  {
    title: "CLIENT_NR",
    key: "Relation.Number",
    cell: "A1",
    shift: 2
  },
  {
    title: "CLIENT_NAME",
    key: "Relation.Name",
    cell: "A2",
    shift: 2
  },
  {
    title: "VAT_STATUS",
    key: "Relation.VATPostingGroup.Description",
    cell: "A3",
    shift: 2
  },
  {
    title: "ACCOUNT_STATEMENTS_PAYMENT",
    key: "PaymentDate",
    type: "date",
    cell: "E1",
    shift: 2
  },
  {
    title: "ACCOUNT_STATEMENTS_SERIAL",
    key: "Version",
    cell: "E2",
    shift: 2
  },
  {
    title: "ACCOUNT_STATEMENTS_DATE",
    key: "DocumentDate",
    type: "date",
    cell: "E3",
    shift: 2
  },
  {
    title: "BALANCE_PREV",
    key: "PreviousBalance",
    type: "currency",
    cell: "F5",
    shift: 1
  },
  {
    title: "BALANCE_MUTATION",
    key: "SaldoMutations",
    type: "currency",
    cell: "F6",
    shift: 1
  },
  {
    title: "TOTAL_INVOICE_AMOUNT",
    key: "SaldoInvoices",
    type: "currency",
    cell: "F7",
    shift: 1
  },
  {
    title: "TOTAL_DEDUCTIONS",
    key: "SaldoDeductionsBlockages",
    cell: "F8",
    type: "currency",
    shift: 1
  },
  {
    title: "ACCOUNT_STATEMENTS_BALANCE",
    key: "EndSaldo",
    cell: "F9",
    type: "currency",
    shift: 1
  }
];

export const columnsInvoices: IColumn[] = [
  {
    title: "INVOICES_DATE",
    key: "Invoice.InvoiceDate",
    type: "date"
  },
  {
    title: "INVOICES_NR",
    key: "Invoice.Number"
  },
  {
    title: "ORDERS_NR",
    key: "Invoice.Order.Number"
  },
  {
    title: "INVOICES_DESCRIPTION",
    key: "InvoiceType.Description",
    width: 35
  },
  {
    title: "INVOICES_AMOUNT",
    key: "OriginalAmount",
    type: "absolute"
  },
  {
    title: "PAID_AMOUNT",
    key: "PaidAmount",
    type: "absolute"
  },
  {
    title: "INVOICES_BALANCE",
    key: "SaldoStatement",
    type: "currency"
  }
];

export const columnsDeductions: IColumn[] = [
  {
    title: "INVOICES_DATE",
    key: "Invoice.InvoiceDate",
    type: "date"
  },
  {
    title: "INVOICES_NR",
    key: "Invoice.Number"
  },
  {
    title: "PAYMENT_DATE",
    key: "Invoice.PaymentDate",
    type: "date"
  },
  {
    title: "REASON",
    key: "OnHold.Description"
  },
  {
    title: "INVOICES_AMOUNT",
    key: "OriginalAmount",
    type: "absolute"
  },
  {
    title: "PAID_AMOUNT",
    key: "PaidAmount",
    type: "absolute"
  },
  {
    title: "INVOICES_BALANCE",
    key: "SaldoStatement",
    type: "currency"
  }
];
